// Connect-the-Dots analysis-mode metadata — used by ConnectionCard,
// ConnectionPage, and the Archive filter dropdown so every published
// connection surfaces its mode consistently across the app.

export const CONNECT_MODES = {
  default:    { label: "Default",    color: "#f472b6", short: "DEFAULT" },
  geographic: { label: "Geographic", color: "#22d3ee", short: "GEO" },
  skeptic:    { label: "Skeptic",    color: "#ffd60a", short: "SKEPTIC" },
  timeline:   { label: "Timeline",   color: "#a78bfa", short: "TIMELINE" },
  occult:     { label: "Occult",     color: "#ec4899", short: "OCCULT" },
  bloodline:  { label: "Bloodline",  color: "#fb923c", short: "BLOODLINE" },
};

export const getConnectMode = (id) => CONNECT_MODES[id] || CONNECT_MODES.default;
